import { Alert, Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { ModalCampaignsProducts } from "../../../../shared/components";
import { useCampaignsProducts } from "../../hooks";
import { TableCampaignsProducts } from "../TableCampaignsProducts";

export const CampaignsProductsPanel = () => {
  const { modalIsOpen, setModalIsOpen, productCount, maxProducts } =
    useCampaignsProducts();
  const atLimit = productCount >= maxProducts;

  return (
    <>
      <Row
        gutter={[8, 8]}
        style={{
          padding: "10px",
          width: "100%",
        }}
      >
        <Col span={24}>
          <Alert
            type={atLimit ? "warning" : "info"}
            showIcon
            message={`${productCount} / ${maxProducts} productos`}
            description={
              atLimit
                ? `Llegaste al máximo. La tienda muestra hasta ${maxProducts} productos de esta campaña.`
                : `La tienda muestra hasta ${maxProducts} productos. Si ya está en la lista, no se puede volver a agregar.`
            }
          />
        </Col>
        <Col
          span={24}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            type="primary"
            shape="round"
            icon={<PlusOutlined />}
            size="large"
            disabled={atLimit}
            onClick={() => setModalIsOpen(true)}
          >
            Agregar producto a la campaña
          </Button>
        </Col>
      </Row>
      <TableCampaignsProducts />
      {modalIsOpen ? (
        <ModalCampaignsProducts
          setModalIsOpen={setModalIsOpen}
          modalIsOpen={modalIsOpen}
        />
      ) : null}
    </>
  );
};

